// Admin API client — /admin/learning-topics/* (mirrors the API's learning-topics aggregate).

import type {
  LearningTopicDoc,
  LearningTopicCreateRequest,
  LearningTopicUpdateRequest,
  LearningTopicListResponse,
  LearningTopicBroadcastResponse,
  LearningTopicStatsResponse,
} from '@a7y/types';
import { client } from './transport';

export const learningTopicsApi = {
  // Learning Topics
  getLearningTopics: async () => {
    const res = await client.get<LearningTopicListResponse>('/learning-topics');
    return res.topics;
  },
  getLearningTopic: async (id: string) => {
    const res = await client.get<{ topic: LearningTopicDoc }>(`/learning-topics/${id}`);
    return res.topic;
  },
  createLearningTopic: async (data: LearningTopicCreateRequest) => {
    const res = await client.post<{ topic: LearningTopicDoc }>('/learning-topics', data);
    return res.topic;
  },
  updateLearningTopic: async (id: string, data: LearningTopicUpdateRequest) => {
    const res = await client.patch<{ topic: LearningTopicDoc }>(`/learning-topics/${id}`, data);
    return res.topic;
  },
  deleteLearningTopic: (id: string) => client.delete<{ message: string }>(`/learning-topics/${id}`),
  broadcastLearningTopic: (id: string) =>
    client.post<LearningTopicBroadcastResponse>(`/learning-topics/${id}/broadcast`),
  getLearningTopicStats: (id: string) =>
    client.get<LearningTopicStatsResponse>(`/learning-topics/${id}/stats`),
};
